import ManualBillingDocumentReference from '@/generated/controls/manualBillingDocument/ManualBillingDocumentReference.vue';
import { defineComponent } from 'vue';

export default defineComponent({
  components: {},
  extends: ManualBillingDocumentReference
})
